import React from 'react';
import './CV.css';

const SidebarProfile = () => (
  <aside className="sidebar-profile">
    <img src="./vinhkhiem_picture_picture.jpg" alt="Khiem Vinh Tran" className="sidebar-profile-img" />
    <h2 className="sidebar-profile-name">Khiem Vinh Tran</h2>
    <p className="sidebar-profile-title">Research Staff Member & Associate Lecturer</p>
    <p className="sidebar-profile-department">Faculty of Information System & Information System Laboratory</p>
    <p className="sidebar-profile-university">University of Information Technology, Vietnam National University, Ho Chi Minh City</p>
    <div className="profile-location">
      <i className="fas fa-map-marker-alt"></i>
      <span>
        <a href="https://maps.app.goo.gl/zVvn2fYphGEJXVRF7" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: '#007bff' }}>
          Room E9.1, UIT-VNUHCM, Quarter 6, Linh Trung, Thu Duc City
        </a>
      </span>
    </div>
    <div className="sidebar-social-links">
      <a href="mailto:khiemtv@uit.edu.vn" className="sidebar-social-link email" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-envelope"></i> Email
      </a>
      <a href="https://scholar.google.com.vn/citations?user=XT2PrJQAAAAJ&hl=vi" className="sidebar-social-link scholar" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-graduation-cap"></i> Google Scholar
      </a>
      <a href="https://orcid.org/0000-0001-7128-2058" className="sidebar-social-link orcid" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-orcid"></i> ORCID
      </a>
      <a href="https://www.linkedin.com/in/khiem-tran-vinh/" className="sidebar-social-link flickr" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-linkedin"></i> LinkedIn
      </a>
      <a href="https://www.instagram.com/kvt0012/" className="sidebar-social-link instagram" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i> Instagram
      </a>
    </div>
  </aside>
);

const CV = () => {
  return (
    <main className="main">
      <div className="sidebar-layout">
        <SidebarProfile />
        <div className="container">
          <div className="page-header">
            <h1>Curriculum Vitae</h1>
          </div>
          <div className="content-section cv-content">
            <h2 className="cv-section-title">Qualifications</h2>
            <ul className="cv-list">
              <li className="cv-item">
                [2025] <strong>MSc, Computer Science, GPA: 4.0/4.0</strong>
                <ul>
                  <li>University of Information Technology, Vietnam National University, Ho Chi Minh City</li>
                  <li>Thesis: "Visual Reasoning for Vietnamese Visual Question Answering "</li>
                  <li>Supervisors: Prof. <a href="https://scholar.google.com.vn/citations?user=VoTCbXYAAAAJ&hl=vi" target="_blank" rel="noopener noreferrer">Ngan Luu Thuy Nguyen</a></li>
                </ul>
              </li>
              <li className="cv-item">
                [2022] <strong>BEng, Information System, GPA: 3.5/4.0</strong>
                <ul>
                  <li>University of Information Technology, Vietnam National University, Ho Chi Minh City</li>
                  <li>Thesis: "Question Answering over Knowledge Graphs for COVID-19"</li>
                  <li>Supervisors: Prof. <a href="https://scholar.google.com.vn/citations?user=VoTCbXYAAAAJ&hl=vi" target="_blank" rel="noopener noreferrer">Ngan Luu Thuy Nguyen</a></li>
                </ul>
              </li>
            </ul>
            <h2 className="cv-section-title">Service</h2>
            <ul className="cv-list">
              <li className="cv-item">
                [2023-present] <strong> ACL Reviewer</strong>
              </li>
              <li className="cv-item">
                [2023-present] <strong> EMNLP Reviewer </strong>
              </li>
                <li className="cv-item">
                  [2023-present] <strong> NAACL Reviewer </strong>
                </li>
                <li className="cv-item">
                  [2023-present] <strong> EACL Reviewer </strong>
                </li>
                <li className="cv-item">
                  [2023-2024] <strong> IEEE Access (Q1) Reviewer </strong>
                </li>
                <li className="cv-item">
                  [2024-present] <strong>  
                  Multimedia Tools and Applications (Q1) reviewer </strong>
                </li>
                <li className="cv-item">
                  [2024-2025] <strong> ACM Computing Surveys (Q1) Reviewer </strong>
                </li>
                <li className="cv-item">
                  [2024-2025] <strong> ACM TIST (Q1) Reviewer </strong>
                </li>
            </ul>
            <h2 className="cv-section-title">Honors and Awards</h2>
            <ul className="cv-list">
              <li className="cv-item">
                <strong> International</strong>
                <ul>
                  <li>[Dec. 2022] <strong>Best paper awards </strong>, RITA Conference 2022</li>
                  <li>[Sep. 2021] <strong>3rd Runner‑up </strong>, WNUT‑2020 Task 2: Identification of Informative COVID‑19 English Tweets</li>
                </ul>
              </li>
              <li className="cv-item">
                <strong>Domestic</strong>
                <ul>
                  <li>[2020-2021] <strong> Academic Encouragement Scholarship </strong>, VNUHCM‑UIT, Scholarships for excellent students</li>
                  <li>[2021] <strong>Student Research Award</strong>, VNUHCM ‑ University of Information Technology</li>
                  <li>[2022-2024] <strong>Academic Encouragement Scholarship 100% tuition fee offsets in 2 years for Master Students</strong>, VNUHCM‑UIT</li>
                  <li>[2023-2024] <strong>VinIF Postgraduate Scholarships</strong>, VINGROUP INNOVATION FOUNDATION for excellent master student</li>
                  <li>[2023-2024] <strong>Valedictorian Master’s Degree</strong>, VNUHCM ‑ University of Information Technology</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CV; 